export default {"src":"/_next/static/image/public/images/ic_up_arrow_green.0f7cc995589cf40016a9699997ab52b8.svg","height":11,"width":19};